<template>
  <div style="display: inline-block">
    <b-btn
      :disabled="disabled"
      style="width: 115px; min-height: 35px;"
      class="mr-1 mt-2" variant="info" @click="showModal">
      Hide Scenarios
    </b-btn>
    <b-modal v-model="modalShown" class="text-left" @ok="select" @cancel="hideModal">
      <div slot="modal-title">Hide Scenarios</div>
      <b-form-group>
        <template v-slot:label>
          <b>Select scenarios to hide:</b><br>
            <b-form-group>
              <b-form-radio-group class="pt-3" id="sort-radio-group" v-model="sortField" 
                    name="sort-radio-sub-component" >
                <label>Sort by: </label>
                <b-form-radio name="name-order" style="margin-left:1rem" value="name">Name</b-form-radio>
                <b-form-radio name="vendor-order" value="B">Vendor</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          <b-form-checkbox
            v-model="allSelected"
            :indeterminate="indeterminate"
            aria-describedby="scenarios"
            aria-controls="scenarios"
            @change="toggleAll"
          >
            {{ allSelected ? 'Un-select All' : 'Select All' }}
          </b-form-checkbox>
        </template>

        <b-form-checkbox-group
          id="scenarios"
          v-model="selected"
          :options="options"
          name="scenarios"
          class="ml-4"
          aria-label="Scenarios to hide"
          stacked
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import naturalSort from 'javascript-natural-sort';
import booleanTrueFalse from '@/filters/booleanTrueFalse';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => true
    },
    scenarios: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const selected = this.scenarios.reduce(
      (acc, { name, hidden }) => (hidden ? [...acc, name] : acc),
      []
    );
    return {
      modalShown: false,
      selected,
      allSelected: selected.length === this.scenarios.length,
      indeterminate: selected.length !== 0 && selected.length !== this.scenarios.length,
      sortField: 'name'
    };
  },
  computed: {
    options() {

      return this.scenarios
        .map((s) => ({
          value: s.name,
          text: (this.sortField === 'name')? s.name + ' - ' + s.vendor :  s.vendor + ' - ' + s.name
        }))
        .sort((a, b) => naturalSort(a.text, b.text));
    }
  },
  methods: {
    showModal() {
      this.modalShown = true;
    },
    hideModal() {
      this.modalShown = false;
    },
    toggleAll(checked) {
      this.selected = checked ? this.scenarios.map(({ name }) => name) : [];
    },
    select() {
      this.$emit('select', this.selected);
      this.hideModal();
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.scenarios.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    }
  }
};
</script>
